// useReleases.js
import { useState } from 'react';
import { useLocation } from 'react-router';
import QueryString from 'query-string';
import { getV3PayloadFromSearch } from '../../branchesV2/branches.service';
import { getMetricsV3 } from 'common/services/metrics.service';
// eslint-disable-next-line lodash/import-scope
import { get } from 'lodash';
import useToast from 'components/hooks/useToast';
import debouncedFetchReleases from './debounceFetchReleases'; // Import the debounced function
import { useSelector } from 'react-redux';
import { allContributorsTeamSelector } from 'state/selectors/teams';

const defaultState = { items: [], total: 0 };

// eslint-disable-next-line jsdoc/require-jsdoc
const fetchReleaseIds = async search => {
  const v3Data = await getMetricsV3(getV3PayloadFromSearch(search));
  const releases = get(v3Data, ['0', 'data', '0', `${search.metric_name}:raw`]);
  return releases?.map(branch => branch?.release_id) || [];
};

// eslint-disable-next-line jsdoc/require-jsdoc
const useReleases = ({ withIncidentsCount }) => {
  const location = useLocation();
  const search = QueryString.parse(location.search, {
    ignoreQueryPrefix: true
  });
  const [isDrilldownMode, setIsDrillDownMode] = useState(
    Boolean(search.metric_name)
  );

  const allContributorsTeam = useSelector(allContributorsTeamSelector);

  const [initialSearch] = useState(search);

  const [releases, setReleases] = useState(defaultState);
  const toast = useToast();

  const fetchReleases = async params => {
    const isAllContributorsTeam =
      allContributorsTeam?.id === params?.filter?.team_ids?.[0];
    await debouncedFetchReleases({
      params,
      withIncidentsCount,
      initialSearch,
      location,
      search,
      fetchReleaseIds,
      setReleases,
      toast,
      isAllContributorsTeam,
      isDrilldownMode
    });
  };

  return {
    releases,
    fetchReleases,
    isDrilldownMode,
    setIsDrillDownMode
  };
};

export default useReleases;
